import { CONFIG_UPDATE } from 'Reducers/config/types';
import { setUrls, urls } from 'Utilities/dataHelpers';
import { normalizeUrl } from 'Utilities/dateHelpers';
import * as log from 'Utilities/log';
import mediator from 'Utilities/mediator';
import { setSessionObject } from 'Utilities/storage';
import { store } from 'Utilities/store';
export const getConfig = (country, app, pId) => {
  return new Promise((resolve, reject) => {
    mediator.request('api:invoke', {
      method: 'GET',
      url: normalizeUrl(urls.libreSharingApiUrl) + 'v1/config',
      headers: {
        'X-User-Agent': app
      },
      params: {
        country,
        pId
      }
    }).then(result => {
      if (result.data) {
        return resolve(result.data);
      }
      reject(result);
    }).catch(err => {
      log.error(err);
      reject(err);
    });
  });
};
export const updateConfig = async (countryParam = 'US', app = '', pId = '', redirect_uri = '', cid = '') => {
  const country = countryParam.toUpperCase();
  const initialConfig = await getConfig(country, app, pId);
  setUrls(initialConfig, country); // set country specific urls

  const countryConfig = await getConfig(country, app, pId); // fetch country specific config

  store.dispatch({
    type: CONFIG_UPDATE,
    config: countryConfig
  });
  setSessionObject('config', countryConfig);
  setSessionObject('env', {
    country,
    app,
    pId,
    redirect_uri,
    cid
  });
};